import React from 'react';

import {
  BlackActionButton,
  CardTitle,
  OutlineActionButton,
  SideCardActions,
  SideCardText,
} from './project-view.styled';

export enum ApplyCardKind {
  Public = 'public',
  Closed = 'closed',
  Offer = 'offer',
  SelfApply = 'self-apply',
}

const PAUSED_LABEL = 'Applications paused';

interface ApplyCardProps {
  kind: ApplyCardKind;
  applyPaused?: boolean;
  onApply: () => void;
  onDecline: () => void;
  onBrowse: () => void;
  onExplore?: () => void;
}

const ApplyCard: React.FC<ApplyCardProps> = ({
  kind,
  applyPaused = false,
  onApply,
  onDecline,
  onBrowse,
  onExplore,
}) => {
  if (kind === ApplyCardKind.Closed) {
    return (
      <>
        <CardTitle>Project closed</CardTitle>
        <SideCardText>
          We no longer accept applications for this project.
        </SideCardText>
        <SideCardActions>
          <BlackActionButton
            type="button"
            onClick={onBrowse}
            data-testid="project-browse"
          >
            Browse open projects
          </BlackActionButton>
        </SideCardActions>
      </>
    );
  }

  if (kind === ApplyCardKind.Offer) {
    return (
      <>
        <CardTitle>Interested in this project?</CardTitle>
        <SideCardText>
          Apply to share your availability, or decline if it&apos;s not a fit.
        </SideCardText>
        <SideCardActions>
          <BlackActionButton
            type="button"
            disabled={applyPaused}
            onClick={onApply}
            data-testid="project-apply"
          >
            {applyPaused ? PAUSED_LABEL : 'Apply to project'}
          </BlackActionButton>
          <OutlineActionButton
            type="button"
            onClick={onDecline}
            data-testid="project-decline"
          >
            Decline offer
          </OutlineActionButton>
        </SideCardActions>
      </>
    );
  }

  return (
    <>
      <CardTitle>
        {applyPaused ? 'Your next step' : 'Looks like a fit?'}
      </CardTitle>
      <SideCardText>
        {applyPaused
          ? 'Interested? Send a short application. Complete or reuse role verification afterward.'
          : 'Hit apply and we’ll guide you through the next steps.'}
      </SideCardText>
      <SideCardActions>
        <BlackActionButton
          type="button"
          disabled={applyPaused}
          onClick={onApply}
          data-testid="project-apply"
        >
          {applyPaused ? PAUSED_LABEL : 'Apply to project'}
        </BlackActionButton>
        {kind === ApplyCardKind.Public && onExplore && (
          <OutlineActionButton
            type="button"
            onClick={onExplore}
            data-testid="project-explore-opportunities"
          >
            Explore other opportunities
          </OutlineActionButton>
        )}
      </SideCardActions>
    </>
  );
};

export default ApplyCard;
